export default "__VITE_ASSET__BvmB5QJY__"